import { getApiClient } from "@punchup/utils/apiRegistry";

interface CreatePendingFollowParams {
  email?: string;
  phone?: string;
  followType: "comedian" | "venue";
  targetId?: string;
  targetSlug?: string;
  followLocation?: string;
}

export async function createPendingFollow(
  params: CreatePendingFollowParams
): Promise<{ success: boolean }> {
  const result = await getApiClient().post<{ data: { success: boolean } }>(
    "/api/v2/public/pending-follows",
    params
  );
  return result.data;
}
